import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { OrbBuddies } from '@aibuild/ui';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { APPS_PHONE_QUERY } from '../../apps.constants';
import { CREATE_APP_TIPS, CREATE_APP_TITLE, HERO_ORB_PX, SHORT_VIEWPORT_QUERY } from './CreateAppHero.constants';
import { Hero, OrbRow, Subtitle, Title } from './CreateAppHero.styled';

const CreateAppHero: React.FC = () => {
  const intl = useIntl();
  const phone = useMediaQuery(APPS_PHONE_QUERY);
  const short = useMediaQuery(SHORT_VIEWPORT_QUERY);
  const tips = useMemo(() => CREATE_APP_TIPS.map((tip) => intl.formatMessage(tip)), [intl]);

  return (
    <Hero>
      {!phone && !short && (
        <OrbRow data-testid="create-app__hero-orb">
          <OrbBuddies size={HERO_ORB_PX} tips={tips} interactive dataTestId="create-app__buddies" />
        </OrbRow>
      )}
      <Title>{intl.formatMessage(CREATE_APP_TITLE)}</Title>
      <Subtitle>
        {intl.formatMessage({
          id: 'apps.builder.create.dialog.subtitle',
          defaultMessage: 'Describe the job, the files it takes and what it hands back.',
        })}
      </Subtitle>
    </Hero>
  );
};

export default CreateAppHero;
